import { organisationConstants } from "../../_constants/organisation.constants";
import { orgImgUploadService } from "../../_services/organisation/orgImgUpload.service.js";
import {organisationAction} from '../organisation.action';

export const organisationImgUpload = {
    postImgUpload,
    removeImgUpload
}

function postImgUpload(data) {
    return dispatch => {
        
        dispatch(request())
        
        orgImgUploadService.postImgService(data)
            .then(
                response => {
                    dispatch(success(response))
                    dispatch(organisationAction.getOrganisation(()=>{}))
                },
                err => {
                    dispatch(error(err))
                }
            )
    }
    function request() { return { type: organisationConstants.ORG_REQUEST_UPLOAD}}
    function success(imgUpload) { return { type: organisationConstants.ORG_RESPONSE_UPLOAD, imgUpload}}
    function error(error) { return  {type: organisationConstants.ORG_ERROR_UPLOAD, error }}
}

function removeImgUpload(data) {
    return dispatch => {
        
        dispatch(request())
        orgImgUploadService.removeImgUploadService(data)
            .then(
                response => {
                    dispatch(success(response))
                    dispatch(organisationAction.getOrganisation(()=>{}))
                },
                err => {
                    dispatch(error(err))
                }
            )
    }
    function request() { return { type: organisationConstants.ORG_REQUEST_DELETE_UPLOAD}}
    function success(removedImage) { return { type: organisationConstants.ORG_RESPONSE_DELETE_UPLOAD, removedImage}}
    function error(error) { return  {type: organisationConstants.ORG_ERROR_DELETE_UPLOAD, error }}
}


// WEBPACK FOOTER //
// ./src/_actions/organisations/orgImgUpload.action.js